<!-- Search-Desktop -->
<div class="hidden md:flex md:w-full md:max-w-[668px]">
  <kaz-search class="md:grow"></kaz-search>
</div>
<!-- Filter - Schnellsuche -->
<div (click)="showFilter()"
  class="hidden h-10 ml-4 text-sm text-[#D2D2D2] font-medium rounded-full cursor-pointer md:flex md:flex-row md:gap-2 md:justify-center md:items-center md:hover:text-kaz-orange">
  <span>Filtern</span>
  <fa-icon icon="filter" size="sm"></fa-icon>
</div>
<!-- Sub-Image -->
<div class="hidden md:grow md:flex md:justify-end">
  <img src="assets/images/newspaper_logo.png"
    class="h-9 w-auto" alt="logo">
</div>
